import { Card } from "@/shared/components/ui/card";
import { useRltLMRAShowQuery } from "@/services/backend/rlt/work-orders/api/lmra-api";
import { useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { ConfirmedLMRAComponent } from "@/services/backend/rlt/work-orders/components/confirmed-lmra";
import { UnconfirmedLMRAComponent } from "@/services/backend/rlt/work-orders/components/unconfirmed-lmra";
import { useRltWorkOrderShowQuery } from "@/services/backend/rlt/work-orders/api/work-order-api";
import t from "@/lang/lang";

export function WorkOrderCompletionLmraRoute() {
  const { lmraId, workOrderId } = useParams();
  const { data: workOrder } = useRltWorkOrderShowQuery({ id: workOrderId! });
  const {
    data: lmra,
    isLoading,
    error,
  } = useRltLMRAShowQuery({
    id: lmraId!,
  });

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!lmra) return null;

  if (lmra.confirmed) {
    return (
      <ConfirmedLMRAComponent
        lmra={lmra}
        disabled={workOrder?.immutable ?? false}
      />
    );
  }
  return (
    <UnconfirmedLMRAComponent
      lmra={lmra}
      disabled={workOrder?.immutable ?? false}
    />
  );
}
